<template>
  <div>
    <b-modal
      v-model="showModalTabelaReservas"
      :show-close="false"
      :noCloseOnBackdrop="true"
      :noCloseOnEsc="true"
      size="xl"
      title="Lista de reservas do período"
    >
      <template #modal-header class="pb-0">
        <div class="w-100 pb-0" style="padding-bottom: 0%">
          <b-row align-h="between" class="pt-2">
            <b-col cols="3" style="margin-left: 5px">
              <el-select
                v-model="pagination.perPage"
                @change="perPageChange"
                placeholder="Por página"
                class="select-primary pagination-select"
                style="margin-bottom: 0%"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </b-col>

            <b-col cols="3" style="margin-right: 5px; margin-bottom: 0%">
              <base-input
                v-model="searchQuery"
                @keyup="searchChange($event)"
                prepend-icon="fas fa-search"
                placeholder="Buscar..."
                style="margin-bottom: 0%"
              ></base-input>
            </b-col>
          </b-row>
        </div>
      </template>

      <div class="pdf-new-page pt-0" style="padding-top: 0%">
        <el-table
          :data="queriedData"
          @sort-change="sortChange"
          @selection-change="selectionChange"
          ref="multipleTable"
          row-key="id"
          class="table-responsive table-flush"
          header-row-class-name="thead-light"
          empty-text="Sem reservas registradas."
          style="padding-bottom: 0%"
        >
          <el-table-column
            width="120"
            align="right"
            prop="id"
            label="Reserva"
            :sortable="true"
          >
            <div slot-scope="{ $index, row }" class="d-flex">
              <a target="_blank" v-bind:href="`/booking-details/${row.code}`"
                >#{{ `${row.code}` }}</a
              >
            </div>
          </el-table-column>

          <el-table-column
            width="230"
            prop="poi.name"
            label="Atrativo"
            :sortable="true"
          >
          </el-table-column>

          <el-table-column
            width="140"
            prop="statusText"
            label="Status"
            :sortable="true"
          >
          </el-table-column>

          <el-table-column
            width="210"
            prop="people"
            label="Pessoas"
            :sortable="true"
          >
            <template slot-scope="scope">
              {{
                scope.row.people.tableText.line1
                  .replace('Visitante (', '')
                  .replace(')', '')
                  .trim()
                  .split('(')[0] || 'nome não informado'
              }}
              <ul style="padding: 0 0 0 15px; list-style: initial">
                <li
                  v-for="(item, key) in scope.row.itemPersonType"
                  v-bind:key="key"
                  style="font-size: smaller"
                >
                  {{
                    scope.row.paymentMethod === 'pos_cortesia'
                      ? 'cortesia'
                      : key.charAt(0).toUpperCase() + key.slice(1)
                  }}
                  : ( {{ item.count }} x R$
                  {{
                    scope.row.paymentMethod === 'pos_cortesia'
                      ? '0,00'
                      : Number(item.block_price)
                          .toFixed(2)
                          .toLocaleString()
                          .replace(',', '')
                          .replace('.', ',')
                  }}
                  )
                </li>
              </ul>
            </template>
          </el-table-column>

          <el-table-column
            width="150"
            prop="checkin"
            align="left"
            label="Check-in"
            :sortable="true"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.checkin.hasCheckin">
                <div
                  v-for="(item, index) in scope.row.checkin.list"
                  :key="index"
                >
                  {{ item.operator }}<br />
                  <sub>
                    {{ formatToLocaleDate(item.date) }}
                  </sub>
                </div>
              </div>

              <div v-else>{{ scope.row.checkin.searchText }}</div>
            </template>
          </el-table-column>

          <el-table-column
            width="150"
            prop="data"
            label="Data"
            :sortable="true"
          >
            <template slot-scope="scope">
              {{ new Date(scope.row.data).toLocaleDateString() }},
              {{ new Date(scope.row.data).toLocaleTimeString() }}
            </template>
          </el-table-column>

          <el-table-column
            width="130"
            label="Valor"
            prop="finalValue"
            :sortable="true"
          >
            <template slot-scope="scope">
              R$
              {{
                scope.row.paymentMethod === 'pos_cortesia'
                  ? '0,00'
                  : scope.row.finalValue
                      .toFixed(2)
                      .toLocaleString()
                      .replace(',', '')
                      .replace('.', ',')
                      .substr(0, 16)
              }}
            </template>
          </el-table-column>

          <!-- <el-table-column width="220" prop="paymentDescription" label="Forma de pagamento" :sortable="true">
                      <template slot-scope="scope">
                        {{ scope.row.paymentDescription }}
                      </template>
                    </el-table-column> -->

          <el-table-column
            width="260"
            prop="confirmPayment"
            label="Confirmação de pagamento"
            :sortable="true"
          >
            <template slot-scope="scope">
              <div>
                <!-- v-if="scope.row.confirmPayment.hasLocalPayment" -->
                <!-- {{ scope.row.channelText }} -  -->
                {{
                  scope.row.confirmPayment.hasLocalPayment
                    ? scope.row.paymentDescription
                    : scope.row.channelText +
                      ' - ' +
                      scope.row.paymentDescription
                }}
              </div>
              <!-- <div v-else>
                              {{ scope.row.channelText }} - {{ scope.row.paymentDescription }}<br />
                            </div> -->

              <sub>
                {{
                  scope.row.datePaid
                    ? new Date(scope.row.datePaid).toLocaleString()
                    : '--'
                }}
              </sub>
            </template>
          </el-table-column>

          <el-table-column
            v-if="showSeeDetails"
            width="80"
            prop="booking_actions"
            label="Detalhes"
            :sortable="false"
          >
            <template slot-scope="scope">
              <span
                @click="setCurrentBooking(scope.row)"
                class="pl-2 btn-inner--icon"
                type="button"
              >
                <i
                  class="no-lg no no-view text-indigo circle"
                  style="padding: 7px"
                ></i>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <template #modal-footer>
        <div class="w-100" style="padding-top: 0%">
          <b-row>
            <b-col class="text-left">
              <p>Mostrando {{ from + 1 }} - {{ to }} de {{ total }} entradas</p>
            </b-col>

            <b-col class="text-left">
              <base-pagination
                :current="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
                @change="paginationChanged($event)"
              >
              </base-pagination>
            </b-col>

            <b-col class="text-right">
              <b-button size="sm" @click="emitCloseModalTabelaReservas"
                >Fechar</b-button
              >
            </b-col>
          </b-row>
        </div>
      </template>
    </b-modal>

    <b-modal
      v-if="openBookingDetailsModal"
      v-model="openBookingDetailsModal"
      modal-class="fullscreen-modal"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
    >
      <template #modal-header style="padding: 0; margin: 0">
        <h2 align-v="start" class="border-bottom w-100 text-left pb-2">
          {{ currentBookingModalTitle }}
        </h2>

        <div class="text-right">
          <button
            @click.prevent="closeBookingDetailsModal"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span @click.prevent="closeBookingDetailsModal">x</span>
          </button>
        </div>
      </template>

      <detalhesda-reserva
        v-if="showSeeDetails && openBookingDetailsModal"
        :bookingCode="currentBookingDetails.code"
        :startDate="startDate"
        :endDate="endDate"
      >
      </detalhesda-reserva>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'
import usePaginateTable from '../../Composables/usePaginateTable'
import DetalhesdaReserva from '../Operacao/DetalhesdaReserva.vue'

export default {
  component: 'ModalTabelaReservas',

  setup(props, context) {
    const paginateTable = usePaginateTable(context)

    const total = paginateTable.total
    const from = paginateTable.from
    const to = paginateTable.to
    const queriedData = paginateTable.queriedData
    const pagination = paginateTable.getPagination()
    const billItems = paginateTable.getBillsItems()
    const searchQuery = paginateTable.searchQuery

    function formatDataLocaleString(oldData) {
      return paginateTable.formatDataLocaleString(oldData)
    }

    function sortChange(data) {
      return paginateTable.sortChange(data)
    }

    function createFuseSearch(keys) {
      return paginateTable.createFuseSearch(keys)
    }

    function setBillItems(items) {
      return paginateTable.setBillsItems(items)
    }

    return {
      total,
      from,
      to,
      queriedData,
      pagination,
      billItems,
      searchQuery,
      formatDataLocaleString,
      sortChange,
      createFuseSearch,
      setBillItems,
    }
  },

  // inject: ['startDate', 'endDate'],

  components: {
    DetalhesdaReserva,
    moment,
  },

  props: {
    hideWhilePrintingPDF: {
      type: Boolean,
      default: false,
    },

    showSeeDetails: {
      type: Boolean,
      default: false,
    },

    transformedItemsArray: {
      type: Object | Array,
      default: {} | [],
    },

    showModalTabelaReservas: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      reloadTable: false,
      currentBookingDetails: null,
      openBookingDetailsModal: false,
    }
  },

  computed: {
    currentBookingModalTitle() {
      return this.currentBookingDetails
        ? `Detalhes da reserva #${this.currentBookingDetails.code}`
        : ''
    },
  },

  watch: {
    transformedItemsArray(newValue, oldValue) {
      if (newValue) {
        this.recreateSearchableTable()
      }
    },
  },

  methods: {
    perPageChange(perPage) {
      this.pagination.perPage = perPage
      this.pagination.currentPage = 1
      this.reloadTable = true
      setTimeout(this.removeLoading, 0)
    },

    paginationChanged(page) {
      this.reloadTable = true
      this.pagination.currentPage = page
      setTimeout(this.removeLoading, 0)
    },

    searchChange(object) {
      // this.reloadTable = true
      // setTimeout(this.removeLoading, 0)
    },

    selectionChange(selectedRows) {
      this.selectedRows = selectedRows
    },

    emitCloseModalTabelaReservas() {
      // this.searchQuery = ''
      this.$emit('emitCloseModalTabelaReservas', false)
    },

    recreateSearchableTable() {
      this.transformedItemsArray.length > 0
        ? this.setBillItems(this.transformedItemsArray)
        : this.setBillItems([])

      // habilitar busca desses campos na tabela pelo mixin
      this.createFuseSearch([
        'data',
        'code',
        'cat',
        'status',
        'statusText',
        'seguro.searchText',
        'people.tableText.line1',
        'people.tableText.line2',
        'people.tableText.line3',
        'paymentMethod',
        'resourcePaymentMethod',
        'poi.address',
        'poi.name',
        'poi.place',
        'valor',
        'id',
      ])
    },

    setCurrentBooking(booking) {
      this.openBookingDetailsModal = true
      this.currentBookingDetails = booking
      // this.$router.push({ path: this.$route.fullPath, hash: "#booking" }).catch((e)=>{console.warn('NavigationDuplicated prevented')})
    },

    closeBookingDetailsModal() {
      this.openBookingDetailsModal = false
      this.currentBookingDetails = null
      // this.$router.push({ path: this.$route.fullPath });
    },
    formatToLocaleDate(date) {
      let formattedDate = '--'
      if (date !== undefined) {
        formattedDate = moment(date, 'DD/MM/YYYY H:mm').isValid()
          ? moment
              .utc(date, 'DD/MM/YYYY H:mm')
              .local()
              .format('DD/MM/YYYY H:mm')
          : moment.utc(date.substr(0, 16)).local().format('DD/MM/YYYY H:mm')
      }
      return formattedDate
    },
  },

  mounted() {
    this.recreateSearchableTable()
  },
}
</script>
